import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import omit from 'lodash/omit';

import { Card, media } from '@material-dev/thread';
import BaseModal from '@material-ui/core/Modal';

const ModalContent = styled(Card)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2),
    0px 13px 19px 2px rgba(0, 0, 0, 0.14),
    0px 5px 24px 4px rgba(0, 0, 0, 0.12);
  margin: 0;
  max-width: ${props => props.maxWidth || '900px'};
  width: auto;
  max-height: 90%;
  overflow: auto;
  width: 90%;

  ${media.md`
    width: auto;
  `}
`;

const Modal = props => (
  <BaseModal {...omit(props, 'maxWidth')}>
    <ModalContent maxWidth={props.maxWidth}>{props.children}</ModalContent>
  </BaseModal>
);

Modal.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.string
};

Modal.defaultProps = {
  maxWidth: '900px'
};

export {
  ModalContent,
  Modal
};



// WEBPACK FOOTER //
// ./src/app/admin/components/Modal/index.js